import Vue from 'vue'
import router from './router'
import store from './store'
import { axios } from '@/utils/request'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { notification } from 'ant-design-vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { connect } from './utils/socket'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['login', 'register', 'registerResult', 'userRegister', 'recover'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start()
  // 存储公钥
  if (to.path === '/user/login') {
    axios({
      url: '/auth/getRsaPulicKey',
      method: 'get',
    }).then(response => {
      localStorage.setItem("PublicKey", response.data.publicKey);
      next();
    })
  }
  if (Vue.ls.get(ACCESS_TOKEN)) {
    /* has token */
    if (to.path === '/user/login') {
      next({
        path:
          location.host == '121.41.10.247:8082' ||
            location.host == 'sjlockan.maitewang.com' ||
            location.host == 'localhost:8000'
            ? '/qyindex/workbench'
            : location.host == 'dxsj.mtwlockan.com' || location.host == 'dxsjlockan.maitewang.com'
              ? '/order/dxOrderList'
              : '/dashboard/weclome'
      })
      NProgress.done()
    } else {
      if (store.getters.roles.length === 0) {
        store
          .dispatch('GetInfo')
          .then(res => {
            // 开启websocket
            connect(res.userId)
            // 调用 vuex 的 从后端获取用户的路由菜单，动态添加可访问路由表
            store.dispatch('GenerateRoutes').then(() => {
              // 把已获取到的路由菜单加入到路由表中
              router.addRoutes(store.getters.addRouters)
              const redirect = decodeURIComponent(from.query.redirect || to.path)
              if (to.path === redirect) {
                // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                next({ ...to, replace: true })
              } else {
                // 跳转到目的路由
                next({ path: redirect })
              }
            })
          })
          .catch(() => {
            notification.error({
              message: '错误',
              description: '请求用户信息失败，请重试'
            })
            store.dispatch('Logout').then(() => {
              next({ path: '/user/login', query: { redirect: to.fullPath } })
            })
          })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/user/login', query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
